jQuery(document).ready(function($){
 
    var currentJewelData = [];

    //set defaults and ranges
  
    var jewelDict = {};

    
    var allTypes = ['Black Opal','Crystal Opal','Milky Opal','Boulder Opal','Doublet Opal','Triplet Opal'];
  
    var availableTypes = [];
    
    var priceMin = '100';
    var priceMax = '50000';
  
  	var optionPrefix = 'opal_';
  
    // Get saved options
	if( 'localStorage' in window ){
      
      if( localStorage.getItem( optionPrefix + 'priceMin' ) ){
         priceMin = localStorage.getItem( optionPrefix + 'priceMin' );
      }
      if( localStorage.getItem( optionPrefix + 'priceMax' ) ){
         priceMax = localStorage.getItem( optionPrefix + 'priceMax' );
      }
      if( localStorage.getItem( optionPrefix + 'type' ) ){
        availableTypes = JSON.parse( localStorage.getItem( optionPrefix + 'type' ) );
        $('.type-list li').removeClass('active-type');
        for( i in availableTypes ){
          $('.type-list li a[title="' + availableTypes[i] + '"]').parent().addClass('active-type');
        }
      }
      
    }
  
    var queryParams = typeof( URLSearchParams ) !== 'undefined' ? ( new URL( document.location ) ).searchParams : new (function( loc ){
        
      this.loc = loc;

      this.params = {};

      var search = location.search.length > 0 ? location.search.substr(1).split('&').map(function( paramstr ){
        return paramstr.split('=');
      }) : [];

      search.forEach(function( param ){
        this.params[ param[0] ] = param[1];
      }.bind( this ) );

      this.has = function( key ){
        return typeof( this.params[ key ] ) !== 'undefined';
      };

      this.get = function( key ){
        return this.params[ key ];
      };

    })( document.location );
  
    // Get options from query string
    if( queryParams.has('type') ){
	  availableTypes = [ queryParams.get('type').toUpperCase() ];
      $('.type-list li').removeClass('active-type');
      for( i in availableTypes ){
        $('.type-list li a[title="' + availableTypes[i] + '"]').parent().addClass('active-type');
      }
    }
  
    var firstLoad = true;

    
    //use ajax to process .csv data
    
    $.ajax({
        type: "GET",
        url: "//www.aodc.net.au/cdn/shop/t/14/assets/opal-db.csv?v=132676186998824408611639629179",
        dataType: "text",
        success: function(data) {processData(data);}
    });
    
    function processData(allText) {
      currentJewelData = $.csv.toObjects(allText);
      for (i = 0; i < currentJewelData.length; ++i) {
        var jewelKey = currentJewelData[i]['Type'];
        if(!(jewelKey in jewelDict)){
          jewelDict[jewelKey] = [];
        }
        jewelDict[jewelKey].push(currentJewelData[i]);
      }
      changeProductSelection('',0,0);
      if( 'localStorage' in window && localStorage.getItem( optionPrefix + 'page' ) ){
        $( '.diamond-list-page[data-page="' + localStorage.getItem( optionPrefix + 'page' ) + '"]' ).click();
        
      }
      $('.loading-notice-bg, .loading-notice').hide(500);
      firstLoad = false;
    }
    
    //This method is called any time a slider is changed
    
    function changeProductSelection(type, min, max){
      var matchedItems = [];
      var pricedItems = [];
      $('#rwd-table tbody').html('');
      var noType = false;
      switch (type){
        case 'price':
          priceMin = min.toString();
          priceMax = max.toString();
		  if( 'localStorage' in window ){
            localStorage.setItem( optionPrefix + 'priceMin', priceMin );
            localStorage.setItem( optionPrefix + 'priceMax', priceMax );
          }
          break;
        case 'type':
          availableTypes = [];
          $('.type-list li').each(function(){
            if($(this).hasClass('active-type')){
              availableTypes.push($(this).children('a').text());
            }
          });
		  if( 'localStorage' in window ){
            localStorage.setItem( optionPrefix + 'type', JSON.stringify( availableTypes ) );
          }
          break;
        default:
          console.log('no type given');
          noType = true;
          break;
      }
      
      for (t = 0; t < availableTypes.length; ++t) {
        var jewelKey = availableTypes[t];
		var ImgList = [];
        if(jewelKey in jewelDict){
          for (j = 0; j < jewelDict[jewelKey].length; ++j){
            var price = parseFloat(jewelDict[jewelKey][j]['Price*'].replace('$','').replace(',',''));
            var rightPrice = price >= parseFloat(priceMin) && price <= parseFloat(priceMax);
            var ProdHandle = ((jewelDict[jewelKey][j]['Technical Description']).replace(/\/|\.|\s+/g, "-").toLowerCase());
            var StockNumber = ((jewelDict[jewelKey][j]['Stock # **']));
            
            //retrieve the product listing to extract current primary image
            jQuery.getJSON('/products/'+StockNumber, function(product) {
  						success(product);	
            } );
            
            
            if(rightPrice){
              
              var html = '';
              html += '<tr class="prod-row" data-stocknumber="' + jewelDict[jewelKey][j]['Stock # **'] + '">';
              html += '  <td> <img class="filterImg" id="img" src="" width=100px; height=100px;/> </td>';
              html += '  <td>' + jewelDict[jewelKey][j]['Technical Description'].toLowerCase(); + '</td>';
              html += '  <td>' + jewelDict[jewelKey][j]['Price*'] + '</td>';
              html += '  <td><div class="view" ><a href="/products/'+(jewelDict[jewelKey][j]['Stock # **'])+'">VIEW</a></div></td>';
              html += '</tr>';
              
              matchedItems.push([
                price,
                html
              ]);

            }

          }
          
        }
      }
      //preview image ajax element update for opal gemstone list
      function success(product)
      {  
        $('.prod-row[data-stocknumber="'+product.product.variants[0].barcode+'"]').find('img').attr('src', product.product.image.src);
      }
      
      if(matchedItems.length > 0){
        matchedItems.sort(function(a,b){
          return a[0] - b[0];
        });
        for (i = 0; i < matchedItems.length; ++i){
          $('#rwd-table tbody').append(matchedItems[i][1]);
          if(i >= 19){
            break;
          }
        }
      }else{
        $('#rwd-table tbody').html('<tr><td colspan="8">No Items Match Your Critera</td></tr>');
      }
      $('.diamond-list-nav').html('');
      if(matchedItems.length > 20){
        $('.diamond-list-nav').show();
        var pages = matchedItems.length / 20;
        for(i=1;i<pages+1;i++){
          $('.diamond-list-nav').append('<div class="diamond-list-page" data-page="'+i+'">'+i+'</div>');
          if(i > 20){
            break;
          }
        }
        $('.diamond-list-page').on('click',function(){
          var pageTop = parseInt($(this).text())*20 - 1;
          var pageBottom = pageTop - 20 + 1;
          $('.diamond-list-page').css('color','#dbb90f');
          $(this).css('color','#e1c9b4');
          $('#rwd-table tbody').html('');
          for (i = pageBottom; i < matchedItems.length; ++i){
            $('#rwd-table tbody').append(matchedItems[i][1]);
            if(i >= pageTop){
              break;
            }
          }
          
          
		  if( 'localStorage' in window ){
            localStorage.setItem( optionPrefix + 'page', $(this).attr('data-page') );
          }
          
          // Reset details hover
          setViewListener();
        });        
      }
      
      if( !firstLoad ){
         localStorage.setItem( optionPrefix + 'page', 1 );
      }
      
      setViewListener();
      if(!noType){
        $('.loading-notice-bg, .loading-notice').hide(500);
      }
    }

  function sortPrices(prices){
    prices.sort(function(a,b){
      return(a.price - b.price);
    });
  }
  
    function setViewListener(){
      $('.prod-row').on('mouseover', function(){
        var depth = $(this).attr('data-depth');
        var stockNo = $(this).attr('data-stocknumber');
        var polish = $(this).attr('data-polish');
        var symmetry = $(this).attr('data-symmetry');
        var table = $(this).attr('data-table');
        var measurements = $(this).attr('data-measurements');
        var certNo = $(this).attr('data-certno');
        var diamondId = $('.'+certNo).attr('id');


        $('.jewel-stock-no .value').text(stockNo);
        $('.jewel-polish .value').text(polish);
        $('.jewel-symmetry .value').text(symmetry);
        $('.jewel-depth .value').text(depth);
        $('.jewel-table .value').text(table);
        $('.jewel-measurements .value').text(measurements);
        $('.cert-no').text(certNo);
        $('.diamond-option').val(diamondId);
        $('.diamond-link').attr('href','/products/'+certNo);
      });
    }
    
    $('.price-slider').slider({
        range: true,
        min: 100,
        max: 50000,
        values: [ parseInt( priceMin ), parseInt( priceMax ) ],
        slide: function( event, ui ) {
          $('.loading-notice-bg, .loading-notice').show();
          $('#price-min').val(ui.values[0]);
          $('#price-max').val(ui.values[1]);
        },
        change: function(event, ui) {
          $('.loading-notice-bg, .loading-notice').show(500);
          changeProductSelection('price', ui.values[0], ui.values[1]);
        }        
    });
    $('#price-min').val($('.price-slider').slider('values', 0));
    $('#price-max').val($('.price-slider').slider('values', 1));
    $('.price-slider').draggable();

    
    $('.type-list li').on('click',function(){
      $(this).toggleClass('active-type');
      changeProductSelection('type',0,0);
    });
  
    $('#price-min, #price-max, #carat-min, #carat-max').keyup( function(){
      priceMin = $('#price-min').val();
      priceMax = $('#price-max').val();
      caratMin = $('#carat-min').val();
      caratMax = $('#carat-max').val();
      changeProductSelection('',0,0);
    });  
  
      
  
    // Float details column if scrolled past
    var $detailsColumn = $('.details-column');
  
    var detailsScrollTop = $detailsColumn.position().top;
    var detailsLeft = $detailsColumn.position().left;
  
    $(window).scroll(function( e ){
      
      if( $(window).width() < 1200 ){
        return; 
      }

      if( $(document).height() > ( detailsScrollTop + ( $detailsColumn.outerHeight() * 2 ) + 130 )  && $(window).scrollTop() >= detailsScrollTop - 130 ){
        $detailsColumn.css({
          'position': 'fixed',
          'width': $detailsColumn.outerWidth(),
          'top': 130,
          'left': detailsLeft - 8
        });
      }else{
        $detailsColumn.css({
          'position': 'relative',
          'width': '',
          'top': 'auto',
          'left': 'auto'
        });
      }
      
    });
  
});